import styled from 'styled-components';
import LoadingShape from 'components/LoadingShape';
import { GREY_300, GREY_800 } from '../../constants';

export const SectionHeader = styled.div`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1.25rem;
    color: ${GREY_300};
    text-transform: uppercase;
    margin-bottom: 0.8125rem;
`;

export const ConversationSummaryContainer = styled.div`
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.4rem;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${GREY_800};
    margin-bottom: 1rem;
`;

export const StyledLoadingShape = styled(LoadingShape)`
    margin-bottom: 5px;
`;
